__turbopack_context__.v({
  "activeBulletPoint": "wordBox-module__dimjPq__activeBulletPoint",
  "wordBox": "wordBox-module__dimjPq__wordBox",
  "wordBoxBulletPoint": "wordBox-module__dimjPq__wordBoxBulletPoint",
  "wordBoxLetters": "wordBox-module__dimjPq__wordBoxLetters",
});
